export enum ESiteStatuses {
    New = 1,
    Active = 2,
    NotActive = 3,
    Deleted = 4,
}
